import React from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from '../components/DataTable';
import { Plus } from 'lucide-react';
import SyncStatus from '../components/SyncStatus';
const Users: React.FC = () => {
  const navigate = useNavigate();
  const columns = [{
    key: 'name',
    label: 'Name',
    sortable: true
  }, {
    key: 'email',
    label: 'Email',
    sortable: true
  }, {
    key: 'account',
    label: 'Account',
    sortable: true
  }, {
    key: 'role',
    label: 'Role',
    sortable: true
  }, {
    key: 'lastActive',
    label: 'Last Active',
    sortable: true
  }, {
    key: 'sessions',
    label: 'Sessions',
    sortable: true
  }, {
    key: 'status',
    label: 'HubSpot Sync',
    sortable: true,
    render: (value: string) => <SyncStatus status={value as 'Synced' | 'Not Synced'} data-id="element-1962" />
  }];
  const mockData = [{
    id: 1,
    name: 'John Smith',
    email: 'john.smith@acme.com',
    account: 'Acme Corporation',
    role: 'Admin',
    lastActive: '2 hours ago',
    sessions: 128,
    status: 'Synced'
  }, {
    id: 2,
    name: 'Sarah Johnson',
    email: 'sarah.j@wayne.com',
    account: 'Wayne Enterprises',
    role: 'User',
    lastActive: '1 day ago',
    sessions: 56,
    status: 'Synced'
  }, {
    id: 3,
    name: 'Michael Brown',
    email: 'm.brown@stark.com',
    account: 'Stark Industries',
    role: 'Admin',
    lastActive: '3 hours ago',
    sessions: 87,
    status: 'Synced'
  }, {
    id: 4,
    name: 'Emily Davis',
    email: 'e.davis@umbrella.com',
    account: 'Umbrella Corporation',
    role: 'User',
    lastActive: '3 days ago',
    sessions: 23,
    status: 'Not Synced'
  }, {
    id: 5,
    name: 'David Wilson',
    email: 'd.wilson@globex.com',
    account: 'Globex Corporation',
    role: 'Manager',
    lastActive: '5 hours ago',
    sessions: 64,
    status: 'Synced'
  }, {
    id: 6,
    name: 'Jessica Lee',
    email: 'j.lee@cyberdyne.com',
    account: 'Cyberdyne Systems',
    role: 'Admin',
    lastActive: '1 hour ago',
    sessions: 43,
    status: 'Synced'
  }, {
    id: 7,
    name: 'Robert Taylor',
    email: 'r.taylor@soylent.com',
    account: 'Soylent Corp',
    role: 'User',
    lastActive: '5 days ago',
    sessions: 12,
    status: 'Not Synced'
  }, {
    id: 8,
    name: 'Amanda Clark',
    email: 'a.clark@initech.com',
    account: 'Initech',
    role: 'User',
    lastActive: '2 days ago',
    sessions: 31,
    status: 'Synced'
  }, {
    id: 9,
    name: 'James Miller',
    email: 'j.miller@massive.com',
    account: 'Massive Dynamic',
    role: 'Admin',
    lastActive: '6 hours ago',
    sessions: 92,
    status: 'Synced'
  }, {
    id: 10,
    name: 'Lisa White',
    email: 'l.white@hooli.com',
    account: 'Hooli',
    role: 'Manager',
    lastActive: '4 hours ago',
    sessions: 76,
    status: 'Synced'
  }];
  const handleRowClick = (user: any) => {
    navigate(`/users/${user.id}`);
  };
  return <div className="space-y-6" data-id="element-1963">
      <div className="flex justify-between items-center" data-id="element-1964">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1965">Users</h1>
        <button className="bg-[#0070d2] hover:bg-[#0057a3] text-white px-4 py-2 rounded-md flex items-center gap-2" data-id="element-1966">
          <Plus size={18} data-id="element-1967" />
          <span data-id="element-1968">New User</span>
        </button>
      </div>
      <div className="grid grid-cols-4 gap-4" data-id="element-1969">
        <div className="bg-white p-4 rounded-md border border-gray-200 shadow-sm" data-id="element-1970">
          <h3 className="text-sm font-medium text-gray-500" data-id="element-1971">Total Users</h3>
          <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1972">1,245</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-1973">↑ 8% from last month</p>
        </div>
        <div className="bg-white p-4 rounded-md border border-gray-200 shadow-sm" data-id="element-1974">
          <h3 className="text-sm font-medium text-gray-500" data-id="element-1975">Active Users</h3>
          <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1976">968</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-1977">↑ 12% from last month</p>
        </div>
        <div className="bg-white p-4 rounded-md border border-gray-200 shadow-sm" data-id="element-1978">
          <h3 className="text-sm font-medium text-gray-500" data-id="element-1979">New Users</h3>
          <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1980">124</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-1981">↑ 15% from last month</p>
        </div>
        <div className="bg-white p-4 rounded-md border border-gray-200 shadow-sm" data-id="element-1982">
          <h3 className="text-sm font-medium text-gray-500" data-id="element-1983">Avg. Sessions</h3>
          <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1984">42</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-1985">↑ 5% from last month</p>
        </div>
      </div>
      <div className="bg-white rounded-md border border-gray-200 shadow-sm overflow-hidden" data-id="element-1986">
        <DataTable columns={columns} data={mockData} onRowClick={handleRowClick} data-id="element-1987" />
      </div>
    </div>;
};
export default Users;